import { Box, Button, Center, Flex, HStack, Image, InputGroup, InputRightElement, Link, Text, VStack, chakra, useToast } from '@chakra-ui/react';
import React from 'react';
import Logo from '../../../images/dashboard/logo_deovita.svg';
import Visitante from '../../../images/login/visitante.svg';
import { ArrowBackIcon, ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import useLogin from './useLogin';
import InputMask from 'react-input-mask';
import { Input } from '@chakra-ui/input';
import { api } from 'api/api';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { isValidCPF } from 'utils/isValidCPF';
import TextField from 'components/TextFieldAuth';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
function Login() {
  const { isPasswordHidden, handleSeePass, navigate, onlyNumbers, error, setError, setUser } = useLogin();
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [usernameError, setUsernameError] = React.useState('');
  const [passwordError, setPasswordError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const onSubmit = async (e) => {
    sessionStorage.removeItem('dashboardValoresTelemedicina');
    sessionStorage.removeItem('dashboardValoresPresenciais');
    e.preventDefault();
    setError(null);
    setUsernameError('');
    setPasswordError('');
    let hasError = false;
    if (!username || !/^([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})$/.test(username)) {
      setUsernameError('CPF obrigatório ou inválido!');
      hasError = true;
    }
    if (!password) {
      setPasswordError('Senha obrigatória!');
      hasError = true;
    }
    if (hasError) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const vals = {
      username: onlyNumbers(username),
      password: password,
    };
    try {
      const res = await api(`${ENDPOINT}/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vals),
      });
      if (!res || !res.ok || res.status >= 400) {
        setLoading(false);
        setError('Não foi possível realizar login no momento. Tente novamente mais tarde.');
        return;
      }
      const data = await res.json();
      setLoading(false);
      if (!data || data.loggedIn === false) {
        setError('CPF ou senha incorretos. Tente novamente.');
        return;
      }
      if (data?.token) {
        localStorage.setItem('token', data.token);
      }
      const postMessageReactNative = {
        event: 'login',
        data: data,
      };
      window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessageReactNative));
      setUser((prevState) => ({
        ...prevState,
        ...data,
        device: prevState.device,
        coords: prevState.coords ? prevState.coords : null,
        build: prevState.build ? prevState.build : null,
      }));
      if (data.status) {
        setError(data.status);
      } else if (data.loggedIn) {
        if (data.id_contrato === 0 && data.titular === true) {
          if (data?.clienteImportado?.clientImportado === true) {
            navigate('/dashboard');
            return;
          }
          if (data.contrato_pendente_pagamento === true) {
            navigate('/cadastro/analise', {
              state: {
                client_id: data.id_cliente_deovita,
                name: data.name,
                cpf: data.cpf,
              },
            });
          } else {
            navigate('/dashboard');
          }
        } else {
          navigate('/dashboard');
        }
      }
    } catch (err) {
      setLoading(false);
      setError('Não foi possível realizar login no momento. Tente novamente mais tarde.');
    }
  };

  const toast = useToast();
  function showToast() {
    toast({
      title: '',
      position: 'top',
      description: 'Sistema em Manutenção',
      status: 'error',
      duration: 2000,
      isClosable: true,
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  return (
    <>
      <Formik
        initialValues={{ username: '', password: '' }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object({
          username: Yup.string()
            .required('CPF obrigatório!')
            .trim()
            .test('cpf-valido', 'CPF inválido', (value) => {
              if (!value) return false;
              const cpfValido = isValidCPF(value);
              if (!cpfValido) {
                setError(true);
                return false;
              }
              return true;
            }),
          password: Yup.string().required('Senha Obrigatória!').min(6, 'Senha inválida!'),
        })}
        onSubmit={(values, actions) => {
          setLoading(true);
          const vals = {
            username: onlyNumbers(values.username),
            password: values.password,
          };

          api(`${ENDPOINT}/auth/login`, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(vals),
          })
            .catch((err) => {
              setLoading(false);
              showToast();
              return;
            })
            .then((res) => {
              setLoading(false);
              if (!res || !res.ok || res.status >= 400) {
                showToast();
                return;
              }
              return res.json();
            })
            .then((data) => {
              setLoading(false);
              if (!data) return;
              if (data?.token) {
                localStorage.setItem('token', data.token);
              }

              if (data.loggedIn === false) {
                setError('CPF ou senha incorretos. Tente novamente.');
                return;
              }

              const postMessageReactNative = {
                event: 'login',
                data: data,
              };
              window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessageReactNative));

              setUser((prevState) => ({
                ...prevState,
                ...data,
                device: prevState.device,
                coords: prevState.coords ? prevState.coords : null,
                build: prevState.build ? prevState.build : null,
              }));
              if (data.status) {
                setError(data.status);
              } else if (data.loggedIn) {
                if (data.id_contrato === 0 && data.titular === true) {
                  if (data?.clienteImportado?.clientImportado === true) {
                    navigate('/dashboard');
                    return;
                  }
                  if (data.contrato_pendente_pagamento === true) {
                    navigate('/cadastro/analise', {
                      state: {
                        client_id: data.id_cliente_deovita,
                        name: data.name,
                        cpf: data.cpf,
                      },
                    });
                  } else {
                    navigate('/dashboard');
                  }
                } else {
                  navigate('/dashboard');
                }
              }
            });
        }}
      >
        {({ values }) => (
          <Flex minH="100dvh" w="100vw" bg="#3FA19C" direction="column" align="center" overflowY="auto" px={4} as={Form}>
            <Box h={{ base: 8, sm: 12, md: 20 }} />
            <Button
              variant="ghost"
              color="white"
              leftIcon={<ArrowBackIcon color="#FFF" boxSize={6} />}
              onClick={() => navigate(-1)}
              mb={2}
              _hover={{ bg: 'rgba(255,255,255,0.1)' }}
              alignSelf="flex-start"
            ></Button>
            <Image
              src={Logo}
              alt="Deovita Logo"
              boxSize={{ base: '180px', md: '220px' }}
              mb={8}
              objectFit="contain"
              borderRadius="2xl"
              p={3}
              mx="auto"
              display="block"
            />
            <Box w="100%" maxW="420px">
              <VStack spacing={6} align="stretch">
                <Box>
                  <chakra.h1 color="white" fontSize="2xl" fontWeight="bold" textAlign="center" mb={2}>
                    Login
                  </chakra.h1>
                  <Text color="white" mb={1} fontWeight={'bold'}>
                    Informe seu CPF<chakra.span color="red"> *</chakra.span>
                  </Text>
                  <TextField
                    name="username"
                    placeholder="xxx.xxx.xxx-xx"
                    mask="999.999.999-99"
                    maskChar={null}
                    type="tel"
                    borderRadius="0.8em"
                    height="3.2em"
                    backgroundColor="white"
                    _placeholder={{ textAlign: 'left', color: '#9E9E9E' }}
                    textAlign={'left'}
                    disabled={loading}
                  />
                  {usernameError && (
                    <Text color="#D62422" fontSize="xs" mt={1} ml={2}>
                      {usernameError}
                    </Text>
                  )}
                </Box>
                <Box minH="140px" display="flex" flexDirection="column" justifyContent="flex-start">
                  {values.username && values.username.replace(/\D/g, '').length === 11 ? (
                    <>
                      <Text color="white" mb={1} fontWeight={'bold'}>
                        Informe sua senha<chakra.span color="red"> *</chakra.span>
                      </Text>
                      <InputGroup>
                        <TextField
                          name="password"
                          type={isPasswordHidden ? 'password' : 'text'}
                          placeholder="********"
                          h="56px"
                          bg="white"
                          borderRadius="lg"
                          autoComplete="current-password"
                          disabled={loading}
                        />
                        <InputRightElement h="100%" pr="1rem">
                          <Button variant="ghost" onClick={handleSeePass}>
                            {isPasswordHidden ? <ViewOffIcon /> : <ViewIcon />}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {error && (
                        <>
                          <Text color="#D62422" textAlign="left" fontSize="md" mb={2} fontWeight={'semibold'}>
                            {error}
                          </Text>
                        </>
                      )}
                      <Button type="submit" bg="white" color="#3FA19C" size="lg" borderRadius="lg" isLoading={loading} mt={5} disabled={loading}>
                        Entrar
                      </Button>
                    </>
                  ) : (
                    <Box h="100%" />
                  )}
                </Box>

                <Text color="white" textAlign="center" fontSize="sm" cursor="pointer" onClick={() => navigate('/recuperacao/cpf')}>
                  Esqueci minha senha
                </Text>
                <Box mt={10} p={6} borderRadius="2xl" bg="rgba(255,255,255,0.2)">
                  <Text color="white" textAlign="center" mb={3} fontWeight={'bold'}>
                    Ainda não tem conta?
                  </Text>
                  <Button bg="white" color="#3FA19C" borderRadius="full" w="100%" mb={4} onClick={() => navigate('/cadastro')}>
                    Cadastre-se agora!
                  </Button>
                </Box>
              </VStack>
            </Box>
            <Box flex="1" minH={{ base: 6, md: 16 }} />
          </Flex>
        )}
      </Formik>
    </>
  );
}

export default Login;
